<div class="wrapper">
  @if (shownLogs().length === 0 && isLoading()) {
    <div class="skeleton-loader">
      <div class="skeleton-line skeleton-text"></div>
      <div class="skeleton-line skeleton-text-short"></div>
      <div class="skeleton-line skeleton-text"></div>
      <div class="skeleton-line skeleton-text-medium"></div>
      <div class="skeleton-line skeleton-text"></div>
      <div class="skeleton-line skeleton-text-short"></div>
      <div class="skeleton-line skeleton-text"></div>
    </div>
  }
  @if (shownLogs().length > 0) {
    @let pulseLog = pulsingLog();
    @for (caseLog of shownLogs(); track caseLog.transitionLogId ?? caseLog.happenedAt; let first = $first; let last = $last) {
      <div
        class="event-slice"
        [class.event-slice--mokk]="!!mokk()"
      >
        <div
          class="event-date"
          [class.highlighted]="first"
        >
          {{ caseLog.happenedAt | date: "yyyy.MM.dd. HH:mm" }}
        </div>
        <div
          class="event-dot"
          [class.done]="caseLog?.status !== 'pending'"
          [class.highlighted]="first"
          [class.last]="last"
          [class.error]="caseLog?.status === 'failed'"
        >
          <div class="event-dot-line"></div>
          <div class="event-dot-circle"></div>
          <div class="event-dot-line"></div>
        </div>
        <div
          class="event-label"
          [class.highlighted]="first"
        >
          <div class="event-title-row">
            @let notificationRoutesTooltip = getEventLabelNotificationRoutesTooltip(caseLog);
            @if (shouldLinkEventLabel(caseLog) && getEventLabelMediaUuid(caseLog); as mediaUuid) {
              <a
                class="event-title-text event-title-link"
                target="_blank"
                rel="noopener noreferrer"
                matTooltipPosition="above"
                matTooltipShowDelay="200"
                matTooltipClass="event-label-notification-tooltip"
                [href]="downloadUrlOfMediaUuid(mediaUuid)"
                [matTooltip]="notificationRoutesTooltip ?? ''"
                [matTooltipDisabled]="!notificationRoutesTooltip"
              >
                {{ caseLog.label }}
              </a>
            } @else {
              <span class="event-title-text">{{ caseLog.label }}</span>
            }
            @if (caseLog.toState; as toState) {
              <span
                class="event-status-arrow"
                aria-hidden="true"
              >
                &rarr;
              </span>
              <span
                class="state-box event-status-chip"
                [class.event-status-chip--ongoing]="caseLog === pulseLog"
                [style.color]="toState.text_color"
                [style.background-color]="toState.background_color"
              >
                <span
                  class="state-marker"
                  [pulse-sync]="3500"
                  [style.background-color]="toState.text_color"
                ></span>
                <span class="state">{{ toState.label }}</span>
              </span>
            }
            @if (mokk(); as mokkContext) {
              @if (caseLog.transitionLogId) {
                <div class="case-events-mokk-actions">
                  @if (isMokkAttachedToLog(caseLog)) {
                    <button
                      mat-icon-button
                      type="button"
                      class="mokk-log-icon-button"
                      matTooltipPosition="before"
                      [disabled]="mokkLinkBusy()"
                      [matTooltip]="'CASE_EVENTS.REMOVE_MOKK_FROM_LOG' | translate"
                      [attr.aria-label]="'CASE_EVENTS.REMOVE_MOKK_FROM_LOG' | translate"
                      (click)="detachMokkFromLog(caseLog, $event)"
                    >
                      <mat-icon>link_off</mat-icon>
                    </button>
                  } @else {
                    @if (mokkContext.transition_logs.length === 0) {
                      <button
                        mat-icon-button
                        type="button"
                        class="mokk-log-icon-button mokk-log-icon-button--attach-hover"
                        matTooltipPosition="before"
                        [disabled]="mokkLinkBusy()"
                        [matTooltip]="'CASE_EVENTS.ATTACH_MOKK_TO_LOG' | translate"
                        [attr.aria-label]="'CASE_EVENTS.ATTACH_MOKK_TO_LOG' | translate"
                        (click)="attachMokkToLog(caseLog, $event)"
                      >
                        <mat-icon>link</mat-icon>
                      </button>
                    }
                  }
                </div>
              }
            }
          </div>
          @if (caseLog.params?.message) {
            <div class="transition-messages">
              <div class="transition-message-title">
                {{ "CASE_EVENTS.MESSAGE_OF_EVENT" | translate }}
              </div>
              <div class="transition-message">
                {{ caseLog.params?.message }}
              </div>
            </div>
          }
          @if (caseLog.params?.bailiff_contact_url) {
            <div class="transition-external-id">
              <div class="transition-external-id-title">
                {{ "CASE_EVENTS.BAILIFF_CONTACT" | translate }}
              </div>
              <div class="transition-external-id-value">
                <a
                  class="transition-file"
                  rel="noopener noreferrer"
                  target="_blank"
                  color="blue-king"
                  [href]="caseLog.params.bailiff_contact_url"
                >
                  <span>{{ caseLog.params.bailiff_contact_url }}</span>
                  <payee-icon
                    name="external-link-blue"
                    height="15px"
                  ></payee-icon>
                </a>
              </div>
            </div>
          } @else if (caseLog.params?.external_id_value) {
            <div class="transition-external-id">
              <div class="transition-external-id-value">
                @if (caseLog.params?.external_id_type) {
                  <span class="transition-external-id-type">{{ getExternalIdTypeLabel(caseLog.params.external_id_type) }}:</span>
                }
                {{ caseLog.params.external_id_value }}
              </div>
            </div>
          }
          @if (caseLog.payments.length) {
            <div class="transition-payments">
              <div
                class="transition-payment-title"
                color="grey-dark"
              >
                {{ "CASE_EVENTS.PAYMENTS_OF_EVENT" | translate }}
              </div>
              @for (payment of caseLog.payments; track payment.label + payment.currency_iso + payment.amount) {
                <div class="transition-payment flex vcenter">
                  <span>{{ payment.label }}:&nbsp;{{ payment.amount | number: "1.0" : "hu" }}&nbsp;{{ payment.currency_iso }}</span>
                  @if (payment.original_amount) {
                    <span color="grey-dark">
                      &nbsp;/&nbsp;{{ payment.original_amount | number: "1.0" : "hu" }}&nbsp;{{ payment.currency_iso }}
                    </span>
                  }
                </div>
              }
            </div>
          }
          @if (shouldShowNotificationLinks(caseLog)) {
            <div class="transition-notifications">
              @for (notification of caseLog.notifications; track notification.subject + (notification.media_uuid ?? "")) {
                <div class="transition-notification">
                  @if (notification.media_uuid; as mediaUuid) {
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      class="transition-notification-link"
                      color="blue-king"
                      matTooltipPosition="above"
                      matTooltipShowDelay="200"
                      matTooltipClass="event-label-notification-tooltip"
                      [href]="downloadUrlOfMediaUuid(mediaUuid)"
                      [matTooltip]="getRoutesTooltip(notification.routes) ?? ''"
                      [matTooltipDisabled]="!getRoutesTooltip(notification.routes)"
                    >
                      <span>{{ notification.subject }}</span>
                    </a>
                  } @else {
                    <span>{{ notification.subject }}</span>
                  }
                </div>
              }
            </div>
          }
          @if (caseLog.files.length) {
            <div class="transition-files">
              <div class="transition-file-title">
                @if (caseLog.files.length === 1) {
                  {{ "CASE_EVENTS.ATTACHMENT" | translate }}
                } @else {
                  {{ "CASE_EVENTS.ATTACHMENTS" | translate }}
                }
              </div>
              @for (file of caseLog.files; track file.id) {
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  class="transition-file"
                  color="blue-king"
                  [href]="downloadUrlOfFile(file)"
                >
                  <payee-icon
                    class="transition-file-icon"
                    name="attachment"
                    height="15px"
                  ></payee-icon>
                  <span>{{ file.file_name }}</span>
                </a>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (hasMoreThanFiveEvents()) {
      <a
        class="show-all-events"
        (click)="toggleShowAllLogs()"
      >
        @if (!showAllLogs()) {
          <span>
            {{ "CASE_EVENTS.SHOW_ALL_EVENTS" | translate }}
          </span>
        }
        @if (showAllLogs()) {
          <span>
            {{ "CASE_EVENTS.SHOW_LESS_EVENTS" | translate }}
          </span>
        }
      </a>
    }
  }
</div>
